import {
  Component, ChangeDetectorRef, Input,
  OnDestroy, Output, EventEmitter,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import * as _ from 'lodash';

import { TableComponent } from '../../../table/table/table.component';
import { createFormControl } from 'utils/form-control';

import { sendBillingData } from '../send-billing-data';
import {takeWhile} from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'send-billing-form',
  templateUrl: 'send-billing-form.component.html',
  styleUrls: ['send-billing-form.component.scss'],
})
export class SendBillingFormComponent extends TableComponent implements OnDestroy {
  form: UntypedFormGroup;
  segmentData = sendBillingData;
  isActive: boolean = true;

  @Output() formDataChanged = new EventEmitter<any>();

  constructor(
    protected ref: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
  ) {
    super();
    this.createForm();
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnDestroy() {
    this.isActive = false;
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public clearForm() {
    this.createForm();
    this.ref.markForCheck();
  }

  public hasError(fieldMap: any, form: any) {
    return form.controls[fieldMap].dirty && super.hasError(fieldMap, form);
  }

  public getPlaceholder(item: any) {
    return item.title;
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private createForm() {
    this.form = new UntypedFormGroup({});
    _.forEach(this.segmentData, (item: any) => {
      this.form.addControl(item.field_map,
        new UntypedFormControl('', this.getItemValidators(item.validation))
      );
    });

    this.form.valueChanges
      .pipe(takeWhile(() => this.isActive))
      .subscribe((form: any) => {
        this.formDataChanged.emit();
      });
    this.ref.markForCheck();
  }
}
